const SERVICE_SUBDOMAINS = new Set([
  'www', 'api', 'auth', 'admin', 'docs', 'kanban', 'chat', 'dev',
  'footsim', 'play', 'tech', 'map', 'calc', 'catalog',
])

const trustedBase = (hostname) => {
  const parts = hostname.split('.')
  return parts.length > 1 && SERVICE_SUBDOMAINS.has(parts[0])
    ? parts.slice(1).join('.')
    : hostname
}

export function safeReturnUrl(rawReturn, currentHref) {
  if (!rawReturn) return null
  try {
    const current = new URL(currentHref)
    const target = new URL(rawReturn, current.origin)
    const base = trustedBase(current.hostname)
    const trustedHost = target.hostname === base || target.hostname.endsWith(`.${base}`)
    if (!['http:', 'https:'].includes(target.protocol) || !trustedHost || target.username || target.password) return null
    return target
  } catch {
    return null
  }
}

export function regionPickerConfig(currentHref) {
  const current = new URL(currentHref)
  const enabled = current.searchParams.get('pick') === 'region'
  if (!enabled) return { enabled: false, returnUrl: null, error: null }
  const returnUrl = safeReturnUrl(current.searchParams.get('return'), currentHref)
  return {
    enabled: true,
    returnUrl,
    error: returnUrl ? null : 'Adresse de retour absente ou non autorisée',
  }
}

export function selectedRegionUrl(returnUrl, regionId) {
  if (!returnUrl || regionId === null || regionId === undefined) return null
  const target = new URL(returnUrl.toString())
  target.searchParams.set('region_id', String(regionId))
  return target.toString()
}
